import { useQuery, useQueryClient } from "@tanstack/react-query";
import TenantAPI from "../../../../api/api/TenantAPI";
import { Schema } from "../../../../types/TenantInterfaces";

export default function useCloudSchema(cloudID: string | undefined) {
  const client = useQueryClient();

  const cloudSchema = useQuery({
    queryKey: ["cloudSchema", cloudID],
    queryFn: () => TenantAPI.getLatestSchema(cloudID),
    enabled: !!cloudID,
    staleTime: Infinity,
  });

  async function getCloudSchema(cloudID: string) {
    const schema = client.getQueryData<Schema>(["cloudSchema", cloudID]);

    if (schema) return schema;

    const fetchedSchema: Schema = await TenantAPI.getLatestSchema(cloudID);
    client.setQueryData<Schema>(["cloudSchema", cloudID], fetchedSchema);
    return fetchedSchema;
  }

  return {
    cloudSchema: cloudSchema.data as Schema | undefined,
    cloudSchemaLoading: cloudSchema.isLoading,
    getCloudSchema: getCloudSchema,
  };
}
